import Hero from "components/organisms/common/Hero"
import useTranslations from "hooks/useTranslations"
import { HeroImage } from "./images"
import LoginButton from "./LoginButton"

/**
 * The CTA is the app login rather than the schools demo booking: parents
 * arrive here from their school to use SomeBuddy, not to buy it.
 */
export default function ParentInfoHero() {
  const {
    parentInfoHeroTitle,
    parentInfoHeroDescription,
    parentInfoHeroHighlight,
  } = useTranslations()

  return (
    <Hero
      Image={HeroImage}
      slides={[parentInfoHeroTitle]}
      description={parentInfoHeroDescription}
      bgColor="green"
      flipImage={false}
      searchWords={parentInfoHeroHighlight || [""]}
      highlightClassName="bg-transparent text-kkm-cream"
      Button={LoginButton}
    />
  )
}
